export const MARKETING_ORIGIN = "https://ophthalmologyq.com";

export function marketingUrl(path: string) {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${MARKETING_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
